import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const TaslkListAllPage = () => {
  return (
    <HomeUI />
  )
}

export default TaslkListAllPage;
